// extracted by mini-css-extract-plugin
export default {"cls1":"PVkO0hSAt3kSO5z7awqS","cls2":"M3i8fu98Giev0xCaGnp_ PVkO0hSAt3kSO5z7awqS"};